import { useContext } from "react"
import { Environment, EnvironmentContext } from "."

export const useEnvironment = (): Environment =>
  useContext(EnvironmentContext)
